module.exports = __webpack_public_path__ + "img/gold-close-icon.c8a7c40f.png";